import type { FuzzySearchResult } from "@repo/app-types/entities/search";
import type { TeammateId } from "@repo/app-types/entities/teammate";
import { BufferWhileExiting } from "@repo/ui/helpers/bufferWhileExiting";
import { modal } from "@repo/ui/Modal/modal";
import { modalOverlay } from "@repo/ui/Modal/modalOverlay";
import type { FC } from "react";
import { Modal, ModalOverlay } from "react-aria-components";
import { SearchDialog } from "./searchDialog.js";

const noop = () => undefined;

export interface SearchModalOverlayProps {
  /** Omit when rendered inside a `DialogTrigger`, which supplies the open state. */
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  placeholder: string;
  resourceTypes: readonly string[] | undefined;
  isTrainingSearchContext: boolean;
  showTranscriptKeywordSearch: boolean;
  isTeamPerformanceSearchContext: boolean;
  transcriptSearchTeammateId: TeammateId | undefined;
  initialSearchQuery?: string;
  onSearchResultsLoad?: (searchResults: readonly FuzzySearchResult[]) => void;
}

export const SearchModalOverlay: FC<SearchModalOverlayProps> = (props) => {
  const {
    isOpen,
    onOpenChange,
    placeholder,
    resourceTypes,
    isTrainingSearchContext,
    showTranscriptKeywordSearch,
    isTeamPerformanceSearchContext,
    transcriptSearchTeammateId,
    initialSearchQuery,
    onSearchResultsLoad,
  } = props;

  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      isDismissable
      className={modalOverlay({
        className: "flex items-start justify-center p-4 pt-[15vh]",
      })}
    >
      <Modal
        className={modal({
          className: "w-full max-w-[600px] overflow-hidden sm:my-0",
        })}
      >
        {(modalProps) => (
          <BufferWhileExiting
            isOpen={modalProps.state.isOpen}
            isExiting={modalProps.isExiting}
          >
            <SearchDialog
              placeholder={placeholder}
              initialSearchQuery={initialSearchQuery}
              resourceTypes={resourceTypes}
              isTrainingSearchContext={isTrainingSearchContext}
              showTranscriptKeywordSearch={showTranscriptKeywordSearch}
              isTeamPerformanceSearchContext={isTeamPerformanceSearchContext}
              transcriptSearchTeammateId={transcriptSearchTeammateId}
              onSearchResultsLoad={onSearchResultsLoad ?? noop}
              close={() => modalProps.state.close()}
            />
          </BufferWhileExiting>
        )}
      </Modal>
    </ModalOverlay>
  );
};
